import CLIENT from "../../lib/api/client";
import ENDPOINTS from "../../lib/api/endpoints";

import { ALL_PAGE_SIZE, normalizeFavouritesPage } from "./favouritesMappers";

export const fetchMyFavourites = async ({
  targetType,
  page = 1,
  pageSize = ALL_PAGE_SIZE,
} = {}) => {
  const params = { page, page_size: pageSize };
  if (targetType) params.target_type = targetType;

  const { data } = await CLIENT.get(ENDPOINTS.FAVOURITES.mine, { params });

  return normalizeFavouritesPage(data);
};

export const setFavourite = async ({ targetType, targetId, saved }) => {
  const { data } = saved
    ? await CLIENT.post(ENDPOINTS.FAVOURITES.root, { targetType, targetId })
    : await CLIENT.delete(ENDPOINTS.FAVOURITES.byTarget(targetType, targetId));

  return { targetType, targetId, saved: data?.saved ?? saved };
};
